export const PAGE_HEADING = "Notification Centre";
export const NO_CONTENT_AVAILABLE_HEADING = "Everything’s looking good!";
export const NO_CONTENT_AVAILABLE_DESCRIPTION = "You have no new notifications";

export const DELETE_ALL = "DELETE ALL";



// WEBPACK FOOTER //
// ./src/features/notification/notification-center/content.js